import { render, staticRenderFns } from "./ActiveDisputes.vue?vue&type=template&id=3f973e27"
import script from "./ActiveDisputes.vue?vue&type=script&lang=js"
export * from "./ActiveDisputes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports